import React from "react";
import HeaderComponent from "../../components/header/header.component";
import { ContentLayout } from "../../layouts/content/content.layout";
import CheckpointDetailsContentComponent from "../../modules/educations/components/checkpoint/checkpoint-details-content/checkpoint-details-content.component";

const CheckpointDetailsPage = (props: any) => {
  const checkpointId = props.match.params.id;

  return (
    <>
      <HeaderComponent />
      <ContentLayout>
        <CheckpointDetailsContentComponent checkpointId={checkpointId} />
      </ContentLayout>
    </>
  );
};
export default CheckpointDetailsPage;
